import type { MediaAsset, MediaFormat, Project } from '../types/content';

export function filterProjects(projects: Project[], area?: Project['area']) {
  return area ? projects.filter((project) => project.area === area) : projects;
}

export function resolveMediaVariant(
  media: MediaAsset,
  targetWidth: number,
  preferredFormat: MediaFormat = 'avif',
) {
  const matching = media.variants
    .filter((variant) => variant.format === preferredFormat)
    .sort((a, b) => a.width - b.width);
  const fallback = media.variants
    .filter((variant) => variant.format === 'webp')
    .sort((a, b) => a.width - b.width);
  const candidates = matching.length ? matching : fallback;
  return candidates.find((variant) => variant.width >= targetWidth) ?? candidates.at(-1) ?? null;
}
